import { useMemo } from 'react';

import { IconJob } from '@components/icons/job';
import { FilterConfigField } from '@components/table';

import { useStore } from 'models/Provider';
import { JobAppliedFilter, JobSearchMenu } from 'pages/Applicants/filter-job-title';

export const useJobsFilter = (): FilterConfigField => {
  const { t } = useStore();

  return useMemo(
    () => ({
      id: 'job_id',
      label: t('messages.filters.job.title'),
      icon: <IconJob />,
      type: 'custom',
      customMenu: JobSearchMenu,
      customAppliedFilter: JobAppliedFilter,
      allowedComparers: ['is', 'any_of'],
      toExternalQuery: (filter) => {
        switch (filter.comparer) {
          case 'is':
          case 'any_of':
            return { application__job_id: filter.value };
          default:
            return {};
        }
      },
    }),
    [t],
  );
};
